import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import TemplatesCategoryViewAll from "./TemplatesCategoryViewAll";
import TemplateCategories from "./TemplateCategories";

class StockTemplates extends Component {
  constructor(props) {
    super(props);
    this.signal = axios.CancelToken.source();
  }

  render() {
    const { artBoardHandler } = this.props;
    return (
      <>
        {this.props.viewAll ? (
          <TemplatesCategoryViewAll artBoardHandler={artBoardHandler} />
        ) : (
          <TemplateCategories artBoardHandler={artBoardHandler} />
        )}
      </>
    );
  }

  componentDidMount() {}

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }
}

StockTemplates.propTypes = {};

StockTemplates.defaultProps = {};

const mapStateToProps = (state) => ({
  viewAll: state.sidebarSlider.viewAll,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StockTemplates);
